const EUR = 'EUR';
const USD = 'USD';
const JPY = 'JPY';

const currencyMap = {
  'USD': 'US Dollar',
  'EUR': 'Euro',
  'JPY': 'Japanese Yen',
};

const getCurrencyDropdownData = () => {
  const dataOptions = [];
  for (const key in currencyMap) {
    dataOptions.push({ value: key, label: currencyMap[key] });
  }
  return dataOptions;
};

const getCurrencySymbol = (key) => {
  const symbolData = {
    "usd": '$',
    "jpy": '¥',
  }
  return key ? (symbolData[key] ? symbolData[key] : '') : '';
};

const getCurrencyText = (priceItem) => {
  let currency = priceItem?.currency;
  return currency ? getCurrencySymbol(currency.toLowerCase()) : "";
};

export { currencyMap, EUR, USD, JPY, getCurrencyDropdownData, getCurrencySymbol, getCurrencyText };

